import { Action, createAction } from 'redux-act';

import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import SpecialHour from '../../../models/interfaces/SpecialHour';
import TimestampPayload from '../TimestampPayload';
import SpecialHourAction from './SpecialHourAction';

export interface AddSpecialHourPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHour: SpecialHour;
}
export const addSpecialHour = createAction<AddSpecialHourPayload>('ADD_SPECIAL_HOUR');
export type AddSpecialHourActionType = Action<AddSpecialHourPayload>;

export interface SpecialHourAddedPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHour: SpecialHour;
  affectedReservations: SeatedReservation[];
}
export const specialHourAdded = createAction<SpecialHourAddedPayload>('SPECIAL_HOUR_ADDED');

export interface SpecialHourAddFailedPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
}
export const specialHourAddFailed = createAction<SpecialHourAddFailedPayload>('SPECIAL_HOUR_ADD_FAILED');
